import i18next from 'i18next'
import React, { useState } from 'react'
import { Link } from '../../utils/links'
import { slugify } from '../../utils/utils'
import { JqueryState } from '../jquery/jqueryState'
import { MailPlusFormState } from '../mailPlusForm/mailPlusFormState'
import { mailPlusFormWidget } from '../mailPlusForm/mailPlusFormWidget'
import { FooterData } from './footerState'

const FooterNewsletter = (props: {
  mailPlusForm: MailPlusFormState
  jquery: JqueryState
  setMailPlusForm: (_: MailPlusFormState) => void
}) =>
  mailPlusFormWidget(
    props.mailPlusForm,
    props.jquery,
    () => <></>,
    false
  ).run(u => props.setMailPlusForm(u(props.mailPlusForm)))

export const FooterLayout = (props: {
  items: FooterData
  showCookiebar: () => void
  trackingCookiesAccepted: boolean
  showPrefooter: boolean
  mailPlusForm: MailPlusFormState
  jquery: JqueryState
  setMailPlusForm: (_: MailPlusFormState) => void
}) => {
  return (
    <footer id="a11y-footer" className="footer">
      <div className="footer__inner">
        {props.showPrefooter && (
          <div className="footer__top">
            <div className="footer__content container--m gutter--m spacing--mx">
              <aside className="block block--membership">
                <div className="block__inner gutter--m spacing--mx">
                  <header className="block__header">
                    <h2 className="block__title title--m">
                      {i18next.t('prefooter:title')}
                    </h2>
                  </header>

                  <div
                    className="block__content text--styled"
                    dangerouslySetInnerHTML={{
                      __html: i18next.t('prefooter:content')
                    }}
                  />

                  <footer className="block__footer block__clickables">
                    <div className="block__clickable">
                      <Link
                        url="/lidmaatschap"
                        className="button button--primary"
                      >
                        <span className="button__label">
                          {i18next.t('prefooter:primaryButtonLabel')}
                        </span>
                      </Link>
                    </div>
                  </footer>
                </div>
              </aside>
            </div>

            <div className="footer__visual fit-object" aria-hidden="true">
              <img
                className="footer__image lazyload"
                width="1440"
                height="960"
                alt=""
                src="/images/empty.png"
                data-src={'/images/footer-bg-720w.jpg'}
                data-srcset={
                  '/images/footer-bg-720w.jpg 720w, /images/footer-bg-1440w.jpg 1440w, /images/footer-bg-2880w.jpg 2880w'
                }
                data-sizes="100vw"
              />
            </div>
          </div>
        )}

        <div className="footer__bottom">
          <nav
            className="footer__nav"
            aria-label={i18next.t('a11y:labelFooterNavigation')}
          >
            <div className="footer__main container--l gutter--m spacing--m">
              <div className="footer__menus">
              <section className="block block--newsletter-footer">
                  <div className="block__inner">
                    <h2 className="block__title title--s">
                      {i18next.t('footer:title')}
                    </h2>
                    <div className="footer__inner__item">
                      <p className="footer__inner__item-label">
                        {i18next.t('footer:emailLabel1')}
                      </p>
                      <a className="footer__link" href={`mailto:${i18next.t('footer:email1')}?subject=${i18next.t('footer:emailLabel1')}`}>
                        {i18next.t('footer:email1')}
                      </a>
                    </div>
                    <div className="footer__inner__item">
                      <p className="footer__inner__item-label">
                        {i18next.t('footer:emailLabel2')}
                      </p>
                      <a className="footer__link" href={`mailto:${i18next.t('footer:email2')}?subject=${i18next.t('footer:emailLabel2')}`}>
                        {i18next.t('footer:email2')}
                      </a>

                    </div>
                    <div className="footer__inner__item">
                      <p className="footer__inner__item-label">
                        {i18next.t('footer:emailLabel3')}
                      </p>
                      <a className="footer__link" href={`mailto:${i18next.t('footer:email3')}?subject=${i18next.t('footer:emailLabel3')}`}>
                        {i18next.t('footer:email3')}
                      </a>

                    </div>
                    <div className="footer__inner__item">
                      <p className="footer__inner__item-label">
                        {i18next.t('footer:emailLabel4')}
                      </p>
                      <a className="footer__link" href={`mailto:${i18next.t('footer:email4')}?subject=${i18next.t('footer:emailLabel4')}`}>
                        {i18next.t('footer:email4')}
                      </a>

                    </div>
                  </div>
                </section>
              </div>

              <div className="vertical__line"></div>

              <div className="footer__newsletter align-top-bottom">
                {/* TODO: hardcoded for now, replace when the newsletter building block is ready */}
                <section className="block block--newsletter-footer">
                  <div className="block__inner">
                    <header className="block__header block__header--intro">
                      <h2 className="block__title title--s">
                        {i18next.t('newsletter:formTitle')}
                      </h2>
                      <p className="block__intro">
                        {i18next.t('newsletter:formIntro')}
                      </p>
                    </header>

                    <div className="block__content">
                      <FooterNewsletter
                        mailPlusForm={props.mailPlusForm}
                        jquery={props.jquery}
                        setMailPlusForm={props.setMailPlusForm}
                      />
                    </div>
                  </div>
                </section>
                <section className="block block--newsletter-footer">
                  <div className="block__inner">
                    <h2 className="block__title title--s">
                    {i18next.t('footer:findUs')}
                    </h2>
                    <p className="block__intro notranslate">{i18next.t('footer:streetAddress')}</p>
                    <p className="block__intro notranslate">{i18next.t('footer:zipcode')}</p>
                    <p className="block__intro">{i18next.t('footer:phone')}</p>
                  </div>
                </section>
              </div>
            </div>

            <div className="footer__legal">
              <div className="footer__legal-inner container--l gutter--m spacing--m">
                <ul className="footer__menu footer__menu--legal text--s">
                  <li className="footer__item">
                    <Link url="/media" className="footer__link">
                      Media
                    </Link>
                  </li>

                  <li className="footer__item">
                    <Link url="https://werken-bij.evofenedex.nl/" className="footer__link">
                      Werken bij
                    </Link>
                  </li>

                  <li className="footer__item">
                    <Link url="/partnerships" className="footer__link">
                      Partnerships
                    </Link>
                  </li>

                  <li className="footer__item">
                    <Link url="/adverteren" className="footer__link">
                      Adverteren
                    </Link>
                  </li>
                </ul>

                <ul className="footer__menu footer__menu--legal text--s">
                  <li className="footer__item">
                    <Link url="/over-de-vereniging" className="footer__link">
                      Over ons
                    </Link>
                  </li>

                  <li className="footer__item">
                    <Link url="/contact" className="footer__link">
                      Contact
                    </Link>
                  </li>

                  <li className="footer__item">
                    <Link
                      url="/algemene-voorwaarden-evofenedex"
                      className="footer__link"
                    >
                      {i18next.t(`footer:termsAndConditionsLinkLabel`)}
                    </Link>
                  </li>

                  <li className="footer__item">
                    <Link url="/cookie-verklaring" className="footer__link">
                      {i18next.t(`footer:cookieStatementLinkLabel`)}
                    </Link>
                  </li>
                </ul>

                <ul className="footer__menu footer__menu--legal text--s">
                  <li className="footer__item">
                    <Link url="/copyright-statement" className="footer__link">
                      {i18next.t(`footer:copyrightStatementLinkLabel`)}
                    </Link>
                  </li>

                  <li className="footer__item">
                    <Link
                      url="/lidmaatschap/lidmaatschapsvoorwaarden"
                      className="footer__link"
                    >
                      {i18next.t(`footer:membershipConditionsLinkLabel`)}
                    </Link>
                  </li>

                  <li className="footer__item">
                    <Link url="/disclaimer" className="footer__link">
                      {i18next.t(`footer:disclaimerLinkLabel`)}
                    </Link>
                  </li>

                  <li className="footer__item">
                    <Link url="/privacy-verklaring" className="footer__link">
                      {i18next.t(`footer:privacyDeclarationLinkLabel`)}
                    </Link>
                  </li>
                </ul>

                <ul className="footer__menu footer__menu--social socials">
                  <li className="socials__item">
                    <a
                      className="socials__link"
                      href="https://www.facebook.com/evofenedex"
                    >
                      <span className="sr-text">Facebook</span>
                      <svg
                        className="socials__icon"
                        width="20px"
                        height="20px"
                        aria-hidden="true"
                      >
                        <use xlinkHref="#icon--facebook" />
                      </svg>
                    </a>
                  </li>

                  <li className="socials__item">
                    <a
                      className="socials__link"
                      href="https://x.com/evofenedex"
                    >
                      <span className="sr-text">X</span>
                      <svg
                        className="socials__icon"
                        width="20px"
                        height="20px"
                        aria-hidden="true"
                      >
                        <use xlinkHref="#icon--x" />
                      </svg>
                    </a>
                  </li>

                  <li className="socials__item">
                    <a
                      className="socials__link"
                      href="https://www.linkedin.com/company/evofenedex"
                    >
                      <span className="sr-text">LinkedIn</span>
                      <svg
                        className="socials__icon"
                        width="20px"
                        height="20px"
                        aria-hidden="true"
                      >
                        <use xlinkHref="#icon--linkedin" />
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </footer>
  )
}
